import { gql } from "@apollo/client";

const PARTNER_USER_FIELDS = `
  _id
  code
  lastName
  firstName
  ghanaCardNumber
  phoneNumber
  emailAddress
  profileImageUrl
`;

const CEWP_USER_FIELDS = `
  _id
  code
  lastName
  firstName
  certificationNumber
  phoneNumber
  emailAddress
  profileImageUrl
`;

const HISTORY_ACTOR_FRAGMENTS = `
  ... on Contractor {
    _id
    name
    code
  }
  ... on ContractorUser {
    _id
    firstName
    lastName
    username
    code
  }
  ... on MeterContractor {
    _id
    name
    code
  }
  ... on MeterContractorUser {
    _id
    firstName
    lastName
    code
  }
  ... on User {
    _id
    firstName
    lastName
    code
  }
  ... on PartnerUser {
    _id
    firstName
    lastName
    code
  }
  ... on CewpUser {
    _id
    firstName
    lastName
    code
  }
`;

export const GET_SERVICE_ORDERS = gql`
  query GetRATServiceOrders(
    $page: Int
    $pageSize: Int
    $sort: String
    $search: String
    $searchFields: [String!]
    $region: ID
    $district: ID
    $partner: ID
    $status: RATServiceOrderStatus
    $priority: RATServiceOrderPriority
    $fromDate: Date
    $toDate: Date
    $dateField: String
  ) {
    rows: getRATServiceOrders(
      page: $page
      pageSize: $pageSize
      sort: $sort
      search: $search
      searchFields: $searchFields
      region: $region
      district: $district
      partner: $partner
      status: $status
      priority: $priority
      fromDate: $fromDate
      toDate: $toDate
      dateField: $dateField
    ) {
      _id
      code
      region {
        _id
        code
        name
      }
      district {
        _id
        code
        name
      }
      digitalAddress
      contactPerson {
        fullName
        phoneNumber
      }
      partner {
        _id
        code
        name
      }
      assigner {
        ${PARTNER_USER_FIELDS}
      }
      approver {
        ${PARTNER_USER_FIELDS}
      }
      disapprover {
        ${PARTNER_USER_FIELDS}
      }
      assignee {
        ${CEWP_USER_FIELDS}
      }
      status
      priority
      result
      notes
      estimatedResolutionDate
      assignedAt
      startedAt
      resolvedAt
      completedAt
      disapprovedAt
      cancelledAt
      createdAt
      updatedAt
    }
    count: getRATServiceOrdersCount(
      search: $search
      searchFields: $searchFields
      region: $region
      district: $district
      partner: $partner
      status: $status
      priority: $priority
      fromDate: $fromDate
      toDate: $toDate
      dateField: $dateField
    )
  }
`;

export const GET_SERVICE_ORDER_SUMMARY = gql`
  query GetRATServiceOrderSummary(
    $region: ID
    $district: ID
    $partner: ID
    $fromDate: Date
    $toDate: Date
    $dateField: String
  ) {
    summary: getRATServiceOrderSummary(
      region: $region
      district: $district
      partner: $partner
      fromDate: $fromDate
      toDate: $toDate
      dateField: $dateField
    ) {
      Pending
      Assigned
      Resolved
      InProgress
      Completed
      Disapproved
      Cancelled
    }
  }
`;

export const GET_SERVICE_ORDER = gql`
  query GetRATServiceOrder($id: ID!) {
    serviceOrder: getRATServiceOrder(id: $id) {
      _id
      code
      region {
        _id
        code
        name
      }
      district {
        _id
        code
        name
      }
      digitalAddress
      contactPerson {
        fullName
        phoneNumber
      }
      partner {
        _id
        code
        name
      }
      assigner {
        ${PARTNER_USER_FIELDS}
      }
      approver {
        ${PARTNER_USER_FIELDS}
      }
      disapprover {
        ${PARTNER_USER_FIELDS}
      }
      assignee {
        ${CEWP_USER_FIELDS}
      }
      cancelledBy {
        ${HISTORY_ACTOR_FRAGMENTS}
      }
      cancelledAt
      cancellationReason
      status
      priority
      result
      resolution {
        notes
        supportingImageUrls
      }
      history {
        actor {
          ${HISTORY_ACTOR_FRAGMENTS}
        }
        assignee {
          ${HISTORY_ACTOR_FRAGMENTS}
        }
        actorType
        assigneeType
        timestamp
        action
        notes
      }
      notes
      estimatedResolutionDate
      assignedAt
      startedAt
      resolvedAt
      completedAt
      disapprovedAt
      createdAt
      updatedAt
    }
  }
`;

export const ASSIGN_SERVICE_ORDER = gql`
  mutation AssignRATServiceOrder(
    $id: ID!
    $assignee: ID!
    $priority: RATServiceOrderPriority!
    $estimatedResolutionDate: Date!
    $digitalAddress: String!
    $notes: String
  ) {
    assignServiceOrder: assignRATServiceOrder(
      id: $id
      assignee: $assignee
      priority: $priority
      estimatedResolutionDate: $estimatedResolutionDate
      digitalAddress: $digitalAddress
      notes: $notes
    ) {
      _id
    }
  }
`;

export const APPROVE_SERVICE_ORDER = gql`
  mutation ApproveRATServiceOrder($id: ID!, $notes: String!) {
    approveServiceOrder: approveRATServiceOrder(id: $id, notes: $notes) {
      _id
    }
  }
`;

export const DISAPPROVE_SERVICE_ORDER = gql`
  mutation DisapproveRATServiceOrder($id: ID!, $reason: String!) {
    disapproveServiceOrder: disapproveRATServiceOrder(
      id: $id
      reason: $reason
    ) {
      _id
    }
  }
`;

export const CANCEL_SERVICE_ORDER = gql`
  mutation CancelRATServiceOrder($id: ID!, $reason: String!) {
    cancelServiceOrder: cancelRATServiceOrder(id: $id, reason: $reason) {
      _id
    }
  }
`;
